import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white h-screen appheader overflow-y-auto px-6 pt-6 pb-[170px]" }
const _hoisted_2 = { class: "p-3 bg-[#2B2C32] border-0 rounded-lg" }
const _hoisted_3 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-5" }
const _hoisted_4 = { class: "w-full xl:w-1/4" }
const _hoisted_5 = { class: "input-wrapper" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "flex mt-2" }
const _hoisted_10 = { class: "w-full xl:w-1/4" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = { class: "absolute bottom-2.5 left-1.5" }
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { class: "w-full xl:w-1/4" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["textContent"]
const _hoisted_17 = { class: "w-full xl:w-1/4" }
const _hoisted_18 = { class: "input-wrapper" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "ml-2 text-sm font-medium uppercase" }
const _hoisted_21 = { class: "w-full xl:w-1/4" }
const _hoisted_22 = { class: "input-wrapper flex xl:justify-end mt-3" }
const _hoisted_23 = { class: "flex gap-3 xl:flex-row flex-col items-start mt-4 mb-4" }
const _hoisted_24 = { class: "w-full xl:w-1/4" }
const _hoisted_25 = { class: "input-wrapper" }
const _hoisted_26 = { class: "text-white text-sm tracking-wider mt-2" }
const _hoisted_27 = { class: "w-full xl:w-1/4" }
const _hoisted_28 = { class: "input-wrapper flex xl:justify-left mt-3 mr-2" }
const _hoisted_29 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_30 = { class: "custom-full" }
const _hoisted_31 = { class: "mt-5 flex justify-between" }
const _hoisted_32 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass('w-full hidden-component')
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_block_loading = _resolveComponent("block-loading")!
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_List = _resolveComponent("List")!
  const _component_CategoryWithProductModal = _resolveComponent("CategoryWithProductModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Nav),
      _createElementVNode("div", _hoisted_2, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mb-3 flex justify-between" }, [
          _createElementVNode("h3", { class: "text-[24px] text-white font-semibold" }, "Earning Points")
        ], -1)),
        (_ctx.loadingEarning)
          ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.loyaltyProgram && _ctx.loyaltyProgram.id)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", {
                            class: _normalizeClass('input-wrapper ' + (_ctx.form.points_per_dollar.error_type))
                          }, [
                            _cache[11] || (_cache[11] = _createElementVNode("label", {
                              class: "block text-white text-xs",
                              for: "name"
                            }, "Earning Rate", -1)),
                            _createElementVNode("div", _hoisted_6, [
                              _withDirectives(_createElementVNode("input", {
                                disabled: !_ctx.is_super_user,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.points_per_dollar.value) = $event)),
                                onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateFields(['points_per_dollar']))),
                                class: "rounded border-none pr-[50px] w-full py-2.5 bg-[#464851] text-white tracking-wider leading-tight focus:outline-none focus:shadow-outline text-sm",
                                placeholder: "1,000",
                                type: "number"
                              }, null, 40, _hoisted_7), [
                                [
                                  _vModelText,
                                  _ctx.form.points_per_dollar.value,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "absolute flex bottom-2 right-2 text-base font-semibold tracking-wider" }, "= $1", -1))
                            ]),
                            (_ctx.form.points_per_dollar.error_message)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: "field-error label-text mt-1",
                                  textContent: _toDisplayString(_ctx.form.points_per_dollar.error_message)
                                }, null, 8, _hoisted_8))
                              : _createCommentVNode("", true)
                          ], 2),
                          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex mt-1" }, [
                            _createElementVNode("span", { class: "text-xs font-normal break-normal text-theme-878686 tracking-wider" }, "You can't change your earning rate for points from here. Please contact your account manager to make changes")
                          ], -1)),
                          _createElementVNode("div", _hoisted_9, [
                            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-xs font-normal break-normal text-theme-878686 tracking-wider" }, "Make sure to update FAQ/Loyalty Terms if you are changing your earning rate", -1)),
                            _createElementVNode("span", null, [
                              _createVNode(_component_mdicon, {
                                size: "20",
                                name: "alert-circle-outline",
                                class: ""
                              })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", {
                          class: _normalizeClass('input-wrapper ' + (_ctx.form.min_purchase_amount.error_type))
                        }, [
                          _cache[14] || (_cache[14] = _createElementVNode("label", {
                            class: "block text-white text-xs",
                            for: "name"
                          }, "Minimum Purchase Total", -1)),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, [
                              _createVNode(_component_mdicon, {
                                size: "20",
                                name: "currency-usd",
                                class: ""
                              })
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.min_purchase_amount.value) = $event)),
                              onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateFields(['min_purchase_amount']))),
                              class: "rounded border-none w-full pl-6 py-2.5 bg-[#464851] text-white tracking-wider leading-tight focus:outline-none focus:shadow-outline text-sm",
                              placeholder: "100,000",
                              type: "number"
                            }, null, 544), [
                              [
                                _vModelText,
                                _ctx.form.min_purchase_amount.value,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          (_ctx.form.min_purchase_amount.error_message)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: "field-error label-text mt-1",
                                textContent: _toDisplayString(_ctx.form.min_purchase_amount.error_message)
                              }, null, 8, _hoisted_13))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", {
                          class: _normalizeClass('input-wrapper ' + (_ctx.form.earn_on.error_type))
                        }, [
                          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block text-white text-xs tracking-[0.4px]" }, "Earn On", -1)),
                          _withDirectives(_createElementVNode("select", {
                            disabled: !_ctx.is_super_user,
                            onOnchange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFields(['earn_on']))),
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.earn_on.value) = $event)),
                            name: "action-type",
                            class: "block tracking-wider border-none rounded bg-gray-black w-full text-white text-sm"
                          }, [...(_cache[15] || (_cache[15] = [
                            _createElementVNode("option", { value: "item" }, "Item", -1),
                            _createElementVNode("option", { value: "cart" }, "Cart", -1)
                          ]))], 40, _hoisted_15), [
                            [_vModelSelect, _ctx.form.earn_on.value]
                          ]),
                          (_ctx.form.earn_on.error_message)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: "field-error label-text mt-1",
                                textContent: _toDisplayString(_ctx.form.earn_on.error_message)
                              }, null, 8, _hoisted_16))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block text-white text-xs tracking-[0.4px]" }, "Reward Accessories Only", -1)),
                          _createElementVNode("label", {
                            class: _normalizeClass(["flex items-center cursor-pointer mt-2", _ctx.can_edit_membership_details ? '' : 'pointer-events-none'])
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.reward_accessories_only) = $event)),
                              disabled: !_ctx.can_edit_membership_details,
                              class: "hidden peer"
                            }, null, 8, _hoisted_19), [
                              [_vModelCheckbox, _ctx.form.reward_accessories_only]
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass('relative toggle-bg border-2 h-6 w-11 rounded-full ' + (_ctx.form.reward_accessories_only ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                            }, null, 2),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.form.reward_accessories_only ? 'ON' : 'OFF'), 1)
                          ], 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          (_ctx.can_edit_membership_details)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.save()), ["prevent"])),
                                class: "bg-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest hover:bg-theme-green hover:text-white",
                                for: ""
                              }, "SAVE"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block text-white text-xs tracking-[0.4px]" }, "Earnable Items", -1)),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.loyaltyProductCountObj.earnable_items) + " " + _toDisplayString(_ctx.loyaltyProductCountObj.earnable_items > 1  ? 'Items' : 'Item') + " selected", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          (_ctx.can_edit_membership_details)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.categoryWithproductObj.active = true), ["prevent"])),
                                class: "bg-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest hover:bg-theme-green hover:text-white",
                                for: ""
                              }, "SELECT"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("p", _hoisted_29, " Loyalty Program is inactive or not set."))
            ], 64)),
        (_ctx.loyaltyProgram && _ctx.loyaltyProgram.id)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass('flex content-main gap-5 ' + (_ctx.action.component ? ' half-it' : ''))
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "text-[24px] text-white font-semibold" }, "Points for Actions", -1)),
                  (!_ctx.action.component && _ctx.can_edit_membership_details)
                    ? (_openBlock(), _createBlock(_component_mdicon, {
                        key: 0,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addUpdate({ component: 'Add', data: {} }))),
                        size: "32",
                        name: "plus",
                        class: "text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"
                      }))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.loyaltyProgram && _ctx.loyaltyProgram.id)
                  ? (_openBlock(), _createBlock(_component_List, {
                      key: 0,
                      selectedCallback: _ctx.selectedItem,
                      loyaltyProgram: _ctx.loyaltyProgram,
                      clearComponent: _ctx.clearComponent,
                      iscomponentactive: _ctx.action.component ? true : false
                    }, null, 8, ["selectedCallback", "loyaltyProgram", "clearComponent", "iscomponentactive"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.action.component)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    (_ctx.loyaltyProgram && _ctx.loyaltyProgram.id)
                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.action.component), {
                          key: 0,
                          loyaltyProgram: { id: _ctx.loyaltyProgram.id },
                          redeemingSetting: { id: _ctx.earningSetting.id, points_for_dollar: _ctx.earningSetting.points_for_dollar  },
                          item: _ctx.action.data,
                          clearComponent: _ctx.clearComponent
                        }, null, 8, ["loyaltyProgram", "redeemingSetting", "item", "clearComponent"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.categoryWithproductObj.active && _ctx.loyaltyProgram.id)
      ? (_openBlock(), _createBlock(_component_CategoryWithProductModal, {
          key: 0,
          loyaltyProgramId: _ctx.loyaltyProgram.id,
          closeClick: _ctx.closeCategoryWithProductModal,
          actionClick: _ctx.setCategoriesWithProduct
        }, null, 8, ["loyaltyProgramId", "closeClick", "actionClick"]))
      : _createCommentVNode("", true)
  ], 64))
}